import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//get user in Group
export const getUserInGroupData = createAsyncThunk('getUserInGroup/getUserInGroupData', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetUsersInGroup?groupName=${encodeURIComponent(value.groupName)}&FQDN=${value.fqdn}`
  );
  return response.data;
});

const initialState = {
  userInGroupLoading: false,
  error: null,
  userInGroup: [],
};

const getUserInGroupSlice = createSlice({
  name: 'getUserInGroupData',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getUserInGroupData.pending, (state) => {
        state.userInGroupLoading = true;
      })
      .addCase(getUserInGroupData.fulfilled, (state, action) => {
        state.userInGroupLoading = false;
        state.userInGroup = action.payload;
        state.error = null;
      })
      .addCase(getUserInGroupData.rejected, (state, action) => {
        state.userInGroupLoading = false;
        state.userInGroup = [];
        state.error = action.error.message;
      });
  },
});
export default getUserInGroupSlice.reducer;
